/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as FullWidthLayoutRouteImport } from './routes/_fullWidthLayout'
import { Route as BaseLayoutRouteImport } from './routes/_baseLayout'
import { Route as AuthLayoutRouteImport } from './routes/_authLayout'
import { Route as BaseLayoutIndexRouteImport } from './routes/_baseLayout/index'
import { Route as FullWidthLayoutInboxIndexRouteImport } from './routes/_fullWidthLayout/inbox/index'
import { Route as BaseLayoutUsersIndexRouteImport } from './routes/_baseLayout/users/index'
import { Route as BaseLayoutRegistrationsIndexRouteImport } from './routes/_baseLayout/registrations/index'
import { Route as BaseLayoutOrganizationsIndexRouteImport } from './routes/_baseLayout/organizations/index'
import { Route as BaseLayoutClubsIndexRouteImport } from './routes/_baseLayout/clubs/index'
import { Route as AuthLayoutVerifyIndexRouteImport } from './routes/_authLayout/verify/index'
import { Route as AuthLayoutResetPasswordIndexRouteImport } from './routes/_authLayout/reset-password/index'
import { Route as AuthLayoutRegisterIndexRouteImport } from './routes/_authLayout/register/index'
import { Route as AuthLayoutLoginIndexRouteImport } from './routes/_authLayout/login/index'
import { Route as AuthLayoutForgottenPasswordIndexRouteImport } from './routes/_authLayout/forgotten-password/index'
import { Route as BaseLayoutUsersCreateRouteImport } from './routes/_baseLayout/users/create'
import { Route as BaseLayoutOrganizationsCreateRouteImport } from './routes/_baseLayout/organizations/create'
import { Route as BaseLayoutChatsCreateRouteImport } from './routes/_baseLayout/chats/create'
import { Route as BaseLayoutUsersProfileIndexRouteImport } from './routes/_baseLayout/users/profile/index'
import { Route as AuthLayoutRegisterSentIndexRouteImport } from './routes/_authLayout/register/sent/index'
import { Route as AuthLayoutForgottenPasswordSentIndexRouteImport } from './routes/_authLayout/forgotten-password/sent/index'
import { Route as BaseLayoutUsersUserIdEditRouteImport } from './routes/_baseLayout/users/$userId/edit'
import { Route as BaseLayoutOrganizationsOrganizationIdSubscriptionsRouteImport } from './routes/_baseLayout/organizations/$organizationId/subscriptions'
import { Route as BaseLayoutOrganizationsOrganizationIdPlanManagementRouteImport } from './routes/_baseLayout/organizations/$organizationId/plan-management'
import { Route as BaseLayoutOrganizationsOrganizationIdPaymentsRouteImport } from './routes/_baseLayout/organizations/$organizationId/payments'
import { Route as BaseLayoutOrganizationsOrganizationIdEditRouteImport } from './routes/_baseLayout/organizations/$organizationId/edit'
import { Route as BaseLayoutOrganizationsOrganizationIdBillingRouteImport } from './routes/_baseLayout/organizations/$organizationId/billing'
import { Route as BaseLayoutChatsChatIdEditRouteImport } from './routes/_baseLayout/chats/$chatId/edit'
import { Route as BaseLayoutChatsChatIdFaqsIndexRouteImport } from './routes/_baseLayout/chats/$chatId/faqs/index'
import { Route as BaseLayoutChatsChatIdDocumentsIndexRouteImport } from './routes/_baseLayout/chats/$chatId/documents/index'
import { Route as BaseLayoutChatsChatIdFaqsCreateRouteImport } from './routes/_baseLayout/chats/$chatId/faqs/create'
import { Route as BaseLayoutChatsChatIdFaqsFaqIdEditRouteImport } from './routes/_baseLayout/chats/$chatId/faqs/$faqId/edit'

const FullWidthLayoutRoute = FullWidthLayoutRouteImport.update({
  id: '/_fullWidthLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const BaseLayoutRoute = BaseLayoutRouteImport.update({
  id: '/_baseLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLayoutRoute = AuthLayoutRouteImport.update({
  id: '/_authLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const BaseLayoutIndexRoute = BaseLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BaseLayoutRoute,
} as any)
const FullWidthLayoutInboxIndexRoute =
  FullWidthLayoutInboxIndexRouteImport.update({
    id: '/inbox/',
    path: '/inbox/',
    getParentRoute: () => FullWidthLayoutRoute,
  } as any)
const BaseLayoutUsersIndexRoute = BaseLayoutUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => BaseLayoutRoute,
} as any)
const BaseLayoutRegistrationsIndexRoute =
  BaseLayoutRegistrationsIndexRouteImport.update({
    id: '/registrations/',
    path: '/registrations/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsIndexRoute =
  BaseLayoutOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutClubsIndexRoute = BaseLayoutClubsIndexRouteImport.update({
  id: '/clubs/',
  path: '/clubs/',
  getParentRoute: () => BaseLayoutRoute,
} as any)
const AuthLayoutVerifyIndexRoute = AuthLayoutVerifyIndexRouteImport.update({
  id: '/verify/',
  path: '/verify/',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthLayoutResetPasswordIndexRoute =
  AuthLayoutResetPasswordIndexRouteImport.update({
    id: '/reset-password/',
    path: '/reset-password/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const AuthLayoutRegisterIndexRoute = AuthLayoutRegisterIndexRouteImport.update({
  id: '/register/',
  path: '/register/',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthLayoutLoginIndexRoute = AuthLayoutLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthLayoutForgottenPasswordIndexRoute =
  AuthLayoutForgottenPasswordIndexRouteImport.update({
    id: '/forgotten-password/',
    path: '/forgotten-password/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const BaseLayoutUsersCreateRoute = BaseLayoutUsersCreateRouteImport.update({
  id: '/users/create',
  path: '/users/create',
  getParentRoute: () => BaseLayoutRoute,
} as any)
const BaseLayoutOrganizationsCreateRoute =
  BaseLayoutOrganizationsCreateRouteImport.update({
    id: '/organizations/create',
    path: '/organizations/create',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsCreateRoute = BaseLayoutChatsCreateRouteImport.update({
  id: '/chats/create',
  path: '/chats/create',
  getParentRoute: () => BaseLayoutRoute,
} as any)
const BaseLayoutUsersProfileIndexRoute =
  BaseLayoutUsersProfileIndexRouteImport.update({
    id: '/users/profile/',
    path: '/users/profile/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const AuthLayoutRegisterSentIndexRoute =
  AuthLayoutRegisterSentIndexRouteImport.update({
    id: '/register/sent/',
    path: '/register/sent/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const AuthLayoutForgottenPasswordSentIndexRoute =
  AuthLayoutForgottenPasswordSentIndexRouteImport.update({
    id: '/forgotten-password/sent/',
    path: '/forgotten-password/sent/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const BaseLayoutUsersUserIdEditRoute =
  BaseLayoutUsersUserIdEditRouteImport.update({
    id: '/users/$userId/edit',
    path: '/users/$userId/edit',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute =
  BaseLayoutOrganizationsOrganizationIdSubscriptionsRouteImport.update({
    id: '/organizations/$organizationId/subscriptions',
    path: '/organizations/$organizationId/subscriptions',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsOrganizationIdPlanManagementRoute =
  BaseLayoutOrganizationsOrganizationIdPlanManagementRouteImport.update({
    id: '/organizations/$organizationId/plan-management',
    path: '/organizations/$organizationId/plan-management',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsOrganizationIdPaymentsRoute =
  BaseLayoutOrganizationsOrganizationIdPaymentsRouteImport.update({
    id: '/organizations/$organizationId/payments',
    path: '/organizations/$organizationId/payments',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsOrganizationIdEditRoute =
  BaseLayoutOrganizationsOrganizationIdEditRouteImport.update({
    id: '/organizations/$organizationId/edit',
    path: '/organizations/$organizationId/edit',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsOrganizationIdBillingRoute =
  BaseLayoutOrganizationsOrganizationIdBillingRouteImport.update({
    id: '/organizations/$organizationId/billing',
    path: '/organizations/$organizationId/billing',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdEditRoute =
  BaseLayoutChatsChatIdEditRouteImport.update({
    id: '/chats/$chatId/edit',
    path: '/chats/$chatId/edit',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdFaqsIndexRoute =
  BaseLayoutChatsChatIdFaqsIndexRouteImport.update({
    id: '/chats/$chatId/faqs/',
    path: '/chats/$chatId/faqs/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdDocumentsIndexRoute =
  BaseLayoutChatsChatIdDocumentsIndexRouteImport.update({
    id: '/chats/$chatId/documents/',
    path: '/chats/$chatId/documents/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdFaqsCreateRoute =
  BaseLayoutChatsChatIdFaqsCreateRouteImport.update({
    id: '/chats/$chatId/faqs/create',
    path: '/chats/$chatId/faqs/create',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdFaqsFaqIdEditRoute =
  BaseLayoutChatsChatIdFaqsFaqIdEditRouteImport.update({
    id: '/chats/$chatId/faqs/$faqId/edit',
    path: '/chats/$chatId/faqs/$faqId/edit',
    getParentRoute: () => BaseLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof BaseLayoutIndexRoute
  '/chats/create': typeof BaseLayoutChatsCreateRoute
  '/organizations/create': typeof BaseLayoutOrganizationsCreateRoute
  '/users/create': typeof BaseLayoutUsersCreateRoute
  '/forgotten-password': typeof AuthLayoutForgottenPasswordIndexRoute
  '/login': typeof AuthLayoutLoginIndexRoute
  '/register': typeof AuthLayoutRegisterIndexRoute
  '/reset-password': typeof AuthLayoutResetPasswordIndexRoute
  '/verify': typeof AuthLayoutVerifyIndexRoute
  '/clubs': typeof BaseLayoutClubsIndexRoute
  '/organizations': typeof BaseLayoutOrganizationsIndexRoute
  '/registrations': typeof BaseLayoutRegistrationsIndexRoute
  '/users': typeof BaseLayoutUsersIndexRoute
  '/inbox': typeof FullWidthLayoutInboxIndexRoute
  '/chats/$chatId/edit': typeof BaseLayoutChatsChatIdEditRoute
  '/organizations/$organizationId/billing': typeof BaseLayoutOrganizationsOrganizationIdBillingRoute
  '/organizations/$organizationId/edit': typeof BaseLayoutOrganizationsOrganizationIdEditRoute
  '/organizations/$organizationId/payments': typeof BaseLayoutOrganizationsOrganizationIdPaymentsRoute
  '/organizations/$organizationId/plan-management': typeof BaseLayoutOrganizationsOrganizationIdPlanManagementRoute
  '/organizations/$organizationId/subscriptions': typeof BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute
  '/users/$userId/edit': typeof BaseLayoutUsersUserIdEditRoute
  '/forgotten-password/sent': typeof AuthLayoutForgottenPasswordSentIndexRoute
  '/register/sent': typeof AuthLayoutRegisterSentIndexRoute
  '/users/profile': typeof BaseLayoutUsersProfileIndexRoute
  '/chats/$chatId/faqs/create': typeof BaseLayoutChatsChatIdFaqsCreateRoute
  '/chats/$chatId/documents': typeof BaseLayoutChatsChatIdDocumentsIndexRoute
  '/chats/$chatId/faqs': typeof BaseLayoutChatsChatIdFaqsIndexRoute
  '/chats/$chatId/faqs/$faqId/edit': typeof BaseLayoutChatsChatIdFaqsFaqIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof BaseLayoutIndexRoute
  '/chats/create': typeof BaseLayoutChatsCreateRoute
  '/organizations/create': typeof BaseLayoutOrganizationsCreateRoute
  '/users/create': typeof BaseLayoutUsersCreateRoute
  '/forgotten-password': typeof AuthLayoutForgottenPasswordIndexRoute
  '/login': typeof AuthLayoutLoginIndexRoute
  '/register': typeof AuthLayoutRegisterIndexRoute
  '/reset-password': typeof AuthLayoutResetPasswordIndexRoute
  '/verify': typeof AuthLayoutVerifyIndexRoute
  '/clubs': typeof BaseLayoutClubsIndexRoute
  '/organizations': typeof BaseLayoutOrganizationsIndexRoute
  '/registrations': typeof BaseLayoutRegistrationsIndexRoute
  '/users': typeof BaseLayoutUsersIndexRoute
  '/inbox': typeof FullWidthLayoutInboxIndexRoute
  '/chats/$chatId/edit': typeof BaseLayoutChatsChatIdEditRoute
  '/organizations/$organizationId/billing': typeof BaseLayoutOrganizationsOrganizationIdBillingRoute
  '/organizations/$organizationId/edit': typeof BaseLayoutOrganizationsOrganizationIdEditRoute
  '/organizations/$organizationId/payments': typeof BaseLayoutOrganizationsOrganizationIdPaymentsRoute
  '/organizations/$organizationId/plan-management': typeof BaseLayoutOrganizationsOrganizationIdPlanManagementRoute
  '/organizations/$organizationId/subscriptions': typeof BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute
  '/users/$userId/edit': typeof BaseLayoutUsersUserIdEditRoute
  '/forgotten-password/sent': typeof AuthLayoutForgottenPasswordSentIndexRoute
  '/register/sent': typeof AuthLayoutRegisterSentIndexRoute
  '/users/profile': typeof BaseLayoutUsersProfileIndexRoute
  '/chats/$chatId/faqs/create': typeof BaseLayoutChatsChatIdFaqsCreateRoute
  '/chats/$chatId/documents': typeof BaseLayoutChatsChatIdDocumentsIndexRoute
  '/chats/$chatId/faqs': typeof BaseLayoutChatsChatIdFaqsIndexRoute
  '/chats/$chatId/faqs/$faqId/edit': typeof BaseLayoutChatsChatIdFaqsFaqIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authLayout': typeof AuthLayoutRouteWithChildren
  '/_baseLayout': typeof BaseLayoutRouteWithChildren
  '/_fullWidthLayout': typeof FullWidthLayoutRouteWithChildren
  '/_baseLayout/': typeof BaseLayoutIndexRoute
  '/_baseLayout/chats/create': typeof BaseLayoutChatsCreateRoute
  '/_baseLayout/organizations/create': typeof BaseLayoutOrganizationsCreateRoute
  '/_baseLayout/users/create': typeof BaseLayoutUsersCreateRoute
  '/_authLayout/forgotten-password/': typeof AuthLayoutForgottenPasswordIndexRoute
  '/_authLayout/login/': typeof AuthLayoutLoginIndexRoute
  '/_authLayout/register/': typeof AuthLayoutRegisterIndexRoute
  '/_authLayout/reset-password/': typeof AuthLayoutResetPasswordIndexRoute
  '/_authLayout/verify/': typeof AuthLayoutVerifyIndexRoute
  '/_baseLayout/clubs/': typeof BaseLayoutClubsIndexRoute
  '/_baseLayout/organizations/': typeof BaseLayoutOrganizationsIndexRoute
  '/_baseLayout/registrations/': typeof BaseLayoutRegistrationsIndexRoute
  '/_baseLayout/users/': typeof BaseLayoutUsersIndexRoute
  '/_fullWidthLayout/inbox/': typeof FullWidthLayoutInboxIndexRoute
  '/_baseLayout/chats/$chatId/edit': typeof BaseLayoutChatsChatIdEditRoute
  '/_baseLayout/organizations/$organizationId/billing': typeof BaseLayoutOrganizationsOrganizationIdBillingRoute
  '/_baseLayout/organizations/$organizationId/edit': typeof BaseLayoutOrganizationsOrganizationIdEditRoute
  '/_baseLayout/organizations/$organizationId/payments': typeof BaseLayoutOrganizationsOrganizationIdPaymentsRoute
  '/_baseLayout/organizations/$organizationId/plan-management': typeof BaseLayoutOrganizationsOrganizationIdPlanManagementRoute
  '/_baseLayout/organizations/$organizationId/subscriptions': typeof BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute
  '/_baseLayout/users/$userId/edit': typeof BaseLayoutUsersUserIdEditRoute
  '/_authLayout/forgotten-password/sent/': typeof AuthLayoutForgottenPasswordSentIndexRoute
  '/_authLayout/register/sent/': typeof AuthLayoutRegisterSentIndexRoute
  '/_baseLayout/users/profile/': typeof BaseLayoutUsersProfileIndexRoute
  '/_baseLayout/chats/$chatId/faqs/create': typeof BaseLayoutChatsChatIdFaqsCreateRoute
  '/_baseLayout/chats/$chatId/documents/': typeof BaseLayoutChatsChatIdDocumentsIndexRoute
  '/_baseLayout/chats/$chatId/faqs/': typeof BaseLayoutChatsChatIdFaqsIndexRoute
  '/_baseLayout/chats/$chatId/faqs/$faqId/edit': typeof BaseLayoutChatsChatIdFaqsFaqIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/chats/create'
    | '/organizations/create'
    | '/users/create'
    | '/forgotten-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify'
    | '/clubs'
    | '/organizations'
    | '/registrations'
    | '/users'
    | '/inbox'
    | '/chats/$chatId/edit'
    | '/organizations/$organizationId/billing'
    | '/organizations/$organizationId/edit'
    | '/organizations/$organizationId/payments'
    | '/organizations/$organizationId/plan-management'
    | '/organizations/$organizationId/subscriptions'
    | '/users/$userId/edit'
    | '/forgotten-password/sent'
    | '/register/sent'
    | '/users/profile'
    | '/chats/$chatId/faqs/create'
    | '/chats/$chatId/documents'
    | '/chats/$chatId/faqs'
    | '/chats/$chatId/faqs/$faqId/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/chats/create'
    | '/organizations/create'
    | '/users/create'
    | '/forgotten-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify'
    | '/clubs'
    | '/organizations'
    | '/registrations'
    | '/users'
    | '/inbox'
    | '/chats/$chatId/edit'
    | '/organizations/$organizationId/billing'
    | '/organizations/$organizationId/edit'
    | '/organizations/$organizationId/payments'
    | '/organizations/$organizationId/plan-management'
    | '/organizations/$organizationId/subscriptions'
    | '/users/$userId/edit'
    | '/forgotten-password/sent'
    | '/register/sent'
    | '/users/profile'
    | '/chats/$chatId/faqs/create'
    | '/chats/$chatId/documents'
    | '/chats/$chatId/faqs'
    | '/chats/$chatId/faqs/$faqId/edit'
  id:
    | '__root__'
    | '/_authLayout'
    | '/_baseLayout'
    | '/_fullWidthLayout'
    | '/_baseLayout/'
    | '/_baseLayout/chats/create'
    | '/_baseLayout/organizations/create'
    | '/_baseLayout/users/create'
    | '/_authLayout/forgotten-password/'
    | '/_authLayout/login/'
    | '/_authLayout/register/'
    | '/_authLayout/reset-password/'
    | '/_authLayout/verify/'
    | '/_baseLayout/clubs/'
    | '/_baseLayout/organizations/'
    | '/_baseLayout/registrations/'
    | '/_baseLayout/users/'
    | '/_fullWidthLayout/inbox/'
    | '/_baseLayout/chats/$chatId/edit'
    | '/_baseLayout/organizations/$organizationId/billing'
    | '/_baseLayout/organizations/$organizationId/edit'
    | '/_baseLayout/organizations/$organizationId/payments'
    | '/_baseLayout/organizations/$organizationId/plan-management'
    | '/_baseLayout/organizations/$organizationId/subscriptions'
    | '/_baseLayout/users/$userId/edit'
    | '/_authLayout/forgotten-password/sent/'
    | '/_authLayout/register/sent/'
    | '/_baseLayout/users/profile/'
    | '/_baseLayout/chats/$chatId/faqs/create'
    | '/_baseLayout/chats/$chatId/documents/'
    | '/_baseLayout/chats/$chatId/faqs/'
    | '/_baseLayout/chats/$chatId/faqs/$faqId/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
  BaseLayoutRoute: typeof BaseLayoutRouteWithChildren
  FullWidthLayoutRoute: typeof FullWidthLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_fullWidthLayout': {
      id: '/_fullWidthLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof FullWidthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_baseLayout': {
      id: '/_baseLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof BaseLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authLayout': {
      id: '/_authLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_baseLayout/': {
      id: '/_baseLayout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof BaseLayoutIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_fullWidthLayout/inbox/': {
      id: '/_fullWidthLayout/inbox/'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof FullWidthLayoutInboxIndexRouteImport
      parentRoute: typeof FullWidthLayoutRoute
    }
    '/_baseLayout/users/': {
      id: '/_baseLayout/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof BaseLayoutUsersIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/registrations/': {
      id: '/_baseLayout/registrations/'
      path: '/registrations'
      fullPath: '/registrations'
      preLoaderRoute: typeof BaseLayoutRegistrationsIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/': {
      id: '/_baseLayout/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof BaseLayoutOrganizationsIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/clubs/': {
      id: '/_baseLayout/clubs/'
      path: '/clubs'
      fullPath: '/clubs'
      preLoaderRoute: typeof BaseLayoutClubsIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_authLayout/verify/': {
      id: '/_authLayout/verify/'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof AuthLayoutVerifyIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authLayout/reset-password/': {
      id: '/_authLayout/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthLayoutResetPasswordIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authLayout/register/': {
      id: '/_authLayout/register/'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthLayoutRegisterIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authLayout/login/': {
      id: '/_authLayout/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLayoutLoginIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authLayout/forgotten-password/': {
      id: '/_authLayout/forgotten-password/'
      path: '/forgotten-password'
      fullPath: '/forgotten-password'
      preLoaderRoute: typeof AuthLayoutForgottenPasswordIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_baseLayout/users/create': {
      id: '/_baseLayout/users/create'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof BaseLayoutUsersCreateRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/create': {
      id: '/_baseLayout/organizations/create'
      path: '/organizations/create'
      fullPath: '/organizations/create'
      preLoaderRoute: typeof BaseLayoutOrganizationsCreateRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/create': {
      id: '/_baseLayout/chats/create'
      path: '/chats/create'
      fullPath: '/chats/create'
      preLoaderRoute: typeof BaseLayoutChatsCreateRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/users/profile/': {
      id: '/_baseLayout/users/profile/'
      path: '/users/profile'
      fullPath: '/users/profile'
      preLoaderRoute: typeof BaseLayoutUsersProfileIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_authLayout/register/sent/': {
      id: '/_authLayout/register/sent/'
      path: '/register/sent'
      fullPath: '/register/sent'
      preLoaderRoute: typeof AuthLayoutRegisterSentIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authLayout/forgotten-password/sent/': {
      id: '/_authLayout/forgotten-password/sent/'
      path: '/forgotten-password/sent'
      fullPath: '/forgotten-password/sent'
      preLoaderRoute: typeof AuthLayoutForgottenPasswordSentIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_baseLayout/users/$userId/edit': {
      id: '/_baseLayout/users/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof BaseLayoutUsersUserIdEditRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/$organizationId/subscriptions': {
      id: '/_baseLayout/organizations/$organizationId/subscriptions'
      path: '/organizations/$organizationId/subscriptions'
      fullPath: '/organizations/$organizationId/subscriptions'
      preLoaderRoute: typeof BaseLayoutOrganizationsOrganizationIdSubscriptionsRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/$organizationId/plan-management': {
      id: '/_baseLayout/organizations/$organizationId/plan-management'
      path: '/organizations/$organizationId/plan-management'
      fullPath: '/organizations/$organizationId/plan-management'
      preLoaderRoute: typeof BaseLayoutOrganizationsOrganizationIdPlanManagementRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/$organizationId/payments': {
      id: '/_baseLayout/organizations/$organizationId/payments'
      path: '/organizations/$organizationId/payments'
      fullPath: '/organizations/$organizationId/payments'
      preLoaderRoute: typeof BaseLayoutOrganizationsOrganizationIdPaymentsRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/$organizationId/edit': {
      id: '/_baseLayout/organizations/$organizationId/edit'
      path: '/organizations/$organizationId/edit'
      fullPath: '/organizations/$organizationId/edit'
      preLoaderRoute: typeof BaseLayoutOrganizationsOrganizationIdEditRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/$organizationId/billing': {
      id: '/_baseLayout/organizations/$organizationId/billing'
      path: '/organizations/$organizationId/billing'
      fullPath: '/organizations/$organizationId/billing'
      preLoaderRoute: typeof BaseLayoutOrganizationsOrganizationIdBillingRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/edit': {
      id: '/_baseLayout/chats/$chatId/edit'
      path: '/chats/$chatId/edit'
      fullPath: '/chats/$chatId/edit'
      preLoaderRoute: typeof BaseLayoutChatsChatIdEditRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/faqs/': {
      id: '/_baseLayout/chats/$chatId/faqs/'
      path: '/chats/$chatId/faqs'
      fullPath: '/chats/$chatId/faqs'
      preLoaderRoute: typeof BaseLayoutChatsChatIdFaqsIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/documents/': {
      id: '/_baseLayout/chats/$chatId/documents/'
      path: '/chats/$chatId/documents'
      fullPath: '/chats/$chatId/documents'
      preLoaderRoute: typeof BaseLayoutChatsChatIdDocumentsIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/faqs/create': {
      id: '/_baseLayout/chats/$chatId/faqs/create'
      path: '/chats/$chatId/faqs/create'
      fullPath: '/chats/$chatId/faqs/create'
      preLoaderRoute: typeof BaseLayoutChatsChatIdFaqsCreateRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/faqs/$faqId/edit': {
      id: '/_baseLayout/chats/$chatId/faqs/$faqId/edit'
      path: '/chats/$chatId/faqs/$faqId/edit'
      fullPath: '/chats/$chatId/faqs/$faqId/edit'
      preLoaderRoute: typeof BaseLayoutChatsChatIdFaqsFaqIdEditRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
  }
}

interface AuthLayoutRouteChildren {
  AuthLayoutForgottenPasswordIndexRoute: typeof AuthLayoutForgottenPasswordIndexRoute
  AuthLayoutLoginIndexRoute: typeof AuthLayoutLoginIndexRoute
  AuthLayoutRegisterIndexRoute: typeof AuthLayoutRegisterIndexRoute
  AuthLayoutResetPasswordIndexRoute: typeof AuthLayoutResetPasswordIndexRoute
  AuthLayoutVerifyIndexRoute: typeof AuthLayoutVerifyIndexRoute
  AuthLayoutForgottenPasswordSentIndexRoute: typeof AuthLayoutForgottenPasswordSentIndexRoute
  AuthLayoutRegisterSentIndexRoute: typeof AuthLayoutRegisterSentIndexRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutForgottenPasswordIndexRoute: AuthLayoutForgottenPasswordIndexRoute,
  AuthLayoutLoginIndexRoute: AuthLayoutLoginIndexRoute,
  AuthLayoutRegisterIndexRoute: AuthLayoutRegisterIndexRoute,
  AuthLayoutResetPasswordIndexRoute: AuthLayoutResetPasswordIndexRoute,
  AuthLayoutVerifyIndexRoute: AuthLayoutVerifyIndexRoute,
  AuthLayoutForgottenPasswordSentIndexRoute:
    AuthLayoutForgottenPasswordSentIndexRoute,
  AuthLayoutRegisterSentIndexRoute: AuthLayoutRegisterSentIndexRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface BaseLayoutRouteChildren {
  BaseLayoutIndexRoute: typeof BaseLayoutIndexRoute
  BaseLayoutChatsCreateRoute: typeof BaseLayoutChatsCreateRoute
  BaseLayoutOrganizationsCreateRoute: typeof BaseLayoutOrganizationsCreateRoute
  BaseLayoutUsersCreateRoute: typeof BaseLayoutUsersCreateRoute
  BaseLayoutClubsIndexRoute: typeof BaseLayoutClubsIndexRoute
  BaseLayoutOrganizationsIndexRoute: typeof BaseLayoutOrganizationsIndexRoute
  BaseLayoutRegistrationsIndexRoute: typeof BaseLayoutRegistrationsIndexRoute
  BaseLayoutUsersIndexRoute: typeof BaseLayoutUsersIndexRoute
  BaseLayoutChatsChatIdEditRoute: typeof BaseLayoutChatsChatIdEditRoute
  BaseLayoutOrganizationsOrganizationIdBillingRoute: typeof BaseLayoutOrganizationsOrganizationIdBillingRoute
  BaseLayoutOrganizationsOrganizationIdEditRoute: typeof BaseLayoutOrganizationsOrganizationIdEditRoute
  BaseLayoutOrganizationsOrganizationIdPaymentsRoute: typeof BaseLayoutOrganizationsOrganizationIdPaymentsRoute
  BaseLayoutOrganizationsOrganizationIdPlanManagementRoute: typeof BaseLayoutOrganizationsOrganizationIdPlanManagementRoute
  BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute: typeof BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute
  BaseLayoutUsersUserIdEditRoute: typeof BaseLayoutUsersUserIdEditRoute
  BaseLayoutUsersProfileIndexRoute: typeof BaseLayoutUsersProfileIndexRoute
  BaseLayoutChatsChatIdFaqsCreateRoute: typeof BaseLayoutChatsChatIdFaqsCreateRoute
  BaseLayoutChatsChatIdDocumentsIndexRoute: typeof BaseLayoutChatsChatIdDocumentsIndexRoute
  BaseLayoutChatsChatIdFaqsIndexRoute: typeof BaseLayoutChatsChatIdFaqsIndexRoute
  BaseLayoutChatsChatIdFaqsFaqIdEditRoute: typeof BaseLayoutChatsChatIdFaqsFaqIdEditRoute
}

const BaseLayoutRouteChildren: BaseLayoutRouteChildren = {
  BaseLayoutIndexRoute: BaseLayoutIndexRoute,
  BaseLayoutChatsCreateRoute: BaseLayoutChatsCreateRoute,
  BaseLayoutOrganizationsCreateRoute: BaseLayoutOrganizationsCreateRoute,
  BaseLayoutUsersCreateRoute: BaseLayoutUsersCreateRoute,
  BaseLayoutClubsIndexRoute: BaseLayoutClubsIndexRoute,
  BaseLayoutOrganizationsIndexRoute: BaseLayoutOrganizationsIndexRoute,
  BaseLayoutRegistrationsIndexRoute: BaseLayoutRegistrationsIndexRoute,
  BaseLayoutUsersIndexRoute: BaseLayoutUsersIndexRoute,
  BaseLayoutChatsChatIdEditRoute: BaseLayoutChatsChatIdEditRoute,
  BaseLayoutOrganizationsOrganizationIdBillingRoute:
    BaseLayoutOrganizationsOrganizationIdBillingRoute,
  BaseLayoutOrganizationsOrganizationIdEditRoute:
    BaseLayoutOrganizationsOrganizationIdEditRoute,
  BaseLayoutOrganizationsOrganizationIdPaymentsRoute:
    BaseLayoutOrganizationsOrganizationIdPaymentsRoute,
  BaseLayoutOrganizationsOrganizationIdPlanManagementRoute:
    BaseLayoutOrganizationsOrganizationIdPlanManagementRoute,
  BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute:
    BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute,
  BaseLayoutUsersUserIdEditRoute: BaseLayoutUsersUserIdEditRoute,
  BaseLayoutUsersProfileIndexRoute: BaseLayoutUsersProfileIndexRoute,
  BaseLayoutChatsChatIdFaqsCreateRoute: BaseLayoutChatsChatIdFaqsCreateRoute,
  BaseLayoutChatsChatIdDocumentsIndexRoute:
    BaseLayoutChatsChatIdDocumentsIndexRoute,
  BaseLayoutChatsChatIdFaqsIndexRoute: BaseLayoutChatsChatIdFaqsIndexRoute,
  BaseLayoutChatsChatIdFaqsFaqIdEditRoute:
    BaseLayoutChatsChatIdFaqsFaqIdEditRoute,
}

const BaseLayoutRouteWithChildren = BaseLayoutRoute._addFileChildren(
  BaseLayoutRouteChildren,
)

interface FullWidthLayoutRouteChildren {
  FullWidthLayoutInboxIndexRoute: typeof FullWidthLayoutInboxIndexRoute
}

const FullWidthLayoutRouteChildren: FullWidthLayoutRouteChildren = {
  FullWidthLayoutInboxIndexRoute: FullWidthLayoutInboxIndexRoute,
}

const FullWidthLayoutRouteWithChildren = FullWidthLayoutRoute._addFileChildren(
  FullWidthLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
  BaseLayoutRoute: BaseLayoutRouteWithChildren,
  FullWidthLayoutRoute: FullWidthLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
